import React from "react"
import Image from "./image"

export default function BlobImgContainer({
  type,
  src,
  text,
  dest,
  children,
  onClick,
}) {
  let svgPath
  let translate
  let id

  switch (type) {
    case "1":
      svgPath =
        "M44.8,-48.1C59.3,-41.2,73.2,-28.3,73.2,-14.9C73.3,-1.5,59.4,12.4,50.3,30C41.3,47.5,37,68.7,25.9,74C14.8,79.3,-3.2,68.6,-22.3,61.5C-41.5,54.5,-61.8,51,-72,38.9C-82.1,26.8,-82.1,6.2,-74.4,-9C-66.8,-24.1,-51.6,-33.8,-38,-40.9C-24.3,-48,-12.1,-52.6,1.5,-54.4C15.1,-56.1,30.2,-55.1,44.8,-48.1Z"
      translate = "-16 -25"
      id = "1"
      break
    case "2":
      svgPath =
        "M52.3,-61.1C59.1,-45.5,50,-22.8,44.7,-5.3C39.4,12.2,38,24.4,31.2,37.6C24.4,50.8,12.2,65,-0.5,65.4C-13.1,65.9,-26.2,52.6,-40.4,39.4C-54.5,26.2,-69.7,13.1,-74.2,-4.5C-78.7,-22.1,-72.5,-44.2,-58.3,-59.8C-44.2,-75.3,-22.1,-84.4,0.3,-84.7C22.8,-85.1,45.5,-76.7,52.3,-61.1Z"
      translate = "-20 -15"
      id = "2"
      break
    case "4":
      svgPath =
        "M40.8,-43.5C56.7,-35.3,76,-26,83.6,-10.6C91.2,4.8,87.2,26.4,76,42.2C64.9,58,46.6,67.9,30.9,65C15.2,62.1,2,46.4,-8.7,36.9C-19.4,27.4,-27.6,24,-39.5,16.4C-51.5,8.9,-67.2,-2.9,-70.1,-16.9C-73,-30.9,-63.1,-47.2,-49.3,-55.8C-35.5,-64.3,-17.8,-65.2,-2.7,-62.1C12.5,-58.9,24.9,-51.7,40.8,-43.5Z"
      translate = "-30 -20"
      id = "4"
      break
    case "5":
      svgPath =
        "M38.1,-50.2C44.6,-39.9,42,-23.4,46.5,-6.9C51,9.7,62.7,26.3,61.4,41.9C60.1,57.5,45.8,72,29.8,74.8C13.8,77.5,-4,68.6,-21.6,61.3C-39.2,54,-56.7,48.4,-60.4,37.2C-64.1,26,-54.1,9.1,-48.9,-6.6C-43.7,-22.3,-43.4,-36.8,-36,-47C-28.7,-57.2,-14.4,-63.1,0.7,-64C15.8,-64.8,31.5,-60.6,38.1,-50.2Z"
      translate = "-20 -30"
      id = "5"
      break
    case "6":
      svgPath =
        "M51.6,-60.2C67.8,-47.9,82.6,-32.5,82.8,-16.8C82.9,-1.1,68.4,15,55.8,27.9C43.2,40.7,32.5,50.3,19.3,56.9C6,63.4,-9.8,66.8,-24.7,63.3C-39.7,59.9,-53.8,49.6,-55.9,36.7C-58.1,23.9,-48.2,8.6,-47.5,-10.6C-46.7,-29.8,-55.2,-52.8,-48.8,-66.9C-42.4,-80.9,-21.2,-86,-1.8,-83.9C17.7,-81.8,35.4,-72.5,51.6,-60.2Z"
      translate = "-30 -10"
      id = "6"
      break
    case "7":
      svgPath =
        "M24.6,-31.8C28.8,-25.8,27,-15.1,35,-1.5C43,12.2,60.9,28.8,59.6,37.6C58.3,46.4,37.9,47.3,21.4,49C5,50.6,-7.6,53.1,-18.8,49.8C-29.9,46.5,-39.6,37.5,-51.1,25.6C-62.6,13.8,-75.9,-1,-76.4,-16.1C-76.8,-31.2,-64.4,-46.6,-49.6,-50.7C-34.7,-54.7,-17.4,-47.3,-3.6,-43.1C10.2,-38.8,20.4,-37.7,24.6,-31.8Z"
      translate = "-20 -30"
      id = "7"
      break
    default:
      svgPath =
        "M26.4,-31.2C38,-21.7,53.8,-17,60.6,-6.5C67.4,3.9,65.1,20.1,56,29C46.9,37.9,31,39.6,17,43C3.1,46.5,-8.8,51.8,-19.7,49.7C-30.6,47.7,-40.5,38.4,-45.8,27.3C-51.2,16.3,-51.9,3.5,-52.3,-11.8C-52.7,-27.1,-52.7,-45,-43.9,-55C-35.1,-65,-17.6,-67.1,-5.1,-61.1C7.4,-55,14.8,-40.7,26.4,-31.2Z"
      translate = "-30 -20"
      id = "7"
  }

  return (
    <div
      style={{
        margin: "20px 10px",
        position: "relative",
        height: "400px",
      }}
    >
      <h2
        style={{
          boxShadow: "-4px 0px #d92027, -8px 0px #ff9234, -12px 0px #ffcd3c",
          margin: "10px auto",
          paddingLeft: "10px",
        }}
      >
        {text}
      </h2>
      <a href={dest} onClick={onClick}>
        <div
          className="jelly"
          style={{
            filter: "drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.7)",
            position: "relative",
          }}
        >
          <div
            style={{
              clipPath: `url(#clip${id})`,
              height: "316px",
              width: "316px",
            }}
          >
            <Image src={src}></Image>
          </div>
        </div>
      </a>
      <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath
            id={`clip${id}`}
            transform={`scale(2 2), translate(${translate})`}
          >
            <path d={svgPath} transform="translate(100 100)" />
          </clipPath>
        </defs>
      </svg>
      {children}
    </div>
  )
}
